import { RxDocument } from 'rxdb'
import { Attr, BaseSchema, ModelSchema } from './helpers'
import { PageSchema } from './PageSchema'
import { AttributeSchema } from './AttributeSchema'
import { UrlSchema } from './UrlSchema'

@ModelSchema({
  name: 'page_template',
  description: 'Any event relating to a page, either a custom one, or a change like updating an attribute',
  version: 0,
  required: ['name'],
  associations: () => [
    { type: 'belongsTo', model: UrlSchema, key: 'owner', foreignKey: 'owner_id' },
    { type: 'belongsTo', model: PageTemplateSchema, key: 'parent', foreignKey: 'parent_id' },
    { type: 'hasMany', model: PageSchema, key: 'pages', foreignKey: 'page_ids' },
    { type: 'hasMany', model: AttributeSchema, key: 'attributes', foreignKey: 'attribute_ids' },
  ],
})
export class PageTemplateSchema extends BaseSchema {
  @Attr({ type: 'string' }) name: string
  @Attr({ type: 'string' }) scope?: string

  @Attr({
    type: 'array',
    items: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        page_template_id: { type: 'string' },
        attribute_id: { type: 'string', ref: 'attributes' },
      },
    },
  }) template_attributes: {
    id: string
    page_template_id: string
    attribute_id: string
  }[]

  owner_id: string
  parent_id?: string
  page_ids?: string[]
  attribute_ids?: string[]
}

export type PageTemplateDoc = RxDocument<PageTemplateSchema>
